const styles = {
  label: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  text: {
    height: '200px'
  }
}

export default styles
